// extracted by mini-css-extract-plugin
module.exports = {"path":"Path_path__1pYOq","bold":"Path_bold__19mNy"};